import React from "react";
import { useNavigate } from "react-router-dom";
import AddCardIcon from "@mui/icons-material/AddCard";

const Main = ({ setHeading }) => {
  const navigate = useNavigate();

  const handleNavigation = (path, heading) => {
    setHeading(heading);
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white-50 to-gray-200 flex items-center justify-center px-3 py-4">
      <div className="w-11/12 max-w-6xl bg-white shadow-md rounded-xl p-5 md:p-6 mt-4">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-6">
          <div
            onClick={() =>
              handleNavigation("/purchase-requisition", "Purchase Requisition")
            }
            className="cursor-pointer group flex flex-col items-center justify-center border border-gray-300 rounded-xl p-4 bg-gradient-to-tr from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 transition-all duration-300 w-full md:w-1/3 shadow-sm hover:shadow-md"
          >
            <div className="bg-blue-600 text-white rounded-full p-3 mb-2 group-hover:scale-110 transition-transform">
              <AddCardIcon fontSize="large" />
            </div>
            <div className="text-sm font-semibold text-gray-800">
              Purchase Requisition
            </div>
          </div>

          <div className="hidden md:block border-l border-gray-300 h-16 mx-6"></div>

          <div className="text-center md:text-left mt-6 md:mt-0 md:w-2/3">
            <h1 className="text-lg font-bold text-gray-800 mb-1">
              Welcome to Purchase Requisition
            </h1>
            <p className="text-gray-600 text-xs">
              Streamline your procurement process by submitting requests with
              ease and transparency.
            </p>
          </div>
        </div>

        {/* Instructions Section */}
        <div className="bg-gray-50 rounded-lg p-4 shadow-inner">
          <h2 className="text-sm font-semibold text-gray-800 mb-3">
            Instructions
          </h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 text-xs leading-relaxed">
            <li>
              Click on the{" "}
              <span className="font-semibold text-blue-600">
                “Purchase Requisition”
              </span>{" "}
              button.
            </li>
            <li>
              Select the type of requisition you want to create (e.g., office
              supplies, equipment, services).
            </li>
            <li>
              Enter Requisition Details:
              <ul className="list-disc list-inside pl-4 mt-1 space-y-1">
                <li>
                  Fill in required fields such as item description, quantity,
                  price, and vendor info.
                </li>
                <li>
                  Provide justification or purpose for the purchase if required.
                </li>
              </ul>
            </li>
            <li>
              Attach Supporting Documents (if applicable):
              <ul className="list-disc list-inside pl-4 mt-1 space-y-1">
                <li>
                  Upload necessary documents like quotes, specs, or approvals to
                  support your requisition.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Main;
